import Tablet from '@material-ui/icons/Tablet';
import OrderList from './list';

export default {
  list: OrderList,
  icon: Tablet,
};
